










import { Component, Vue } from "vue-property-decorator";
import * as echarts from "echarts";
@Component({
  components: {},
})
export default class Home extends Vue {
  public loading = false;
  public chartLine: any = "";
  public titleList = [];
  public dateList = [];
  public seriesList = [];
  public timeShow = false;
  public pastDateList = [];
  public title = "";
  public showTitleList: any = [];
  public show(
    titleList,
    dateList,
    seriesList,
    timeShow,
    pastDateList,
    title,
    showTitleList
  ) {
    this.loading = true;
    this.titleList = titleList;
    this.dateList = dateList;
    this.seriesList = seriesList;
    this.timeShow = timeShow;
    this.pastDateList = pastDateList;
    this.title = title;
    this.showTitleList = showTitleList;
    this.$nextTick(() => {
      setTimeout(() => {
        this.getInit();
      });
    });
  }
  public getInit() {
    if (
      this.chartLine != null &&
      this.chartLine != "" &&
      this.chartLine != undefined
    ) {
      this.chartLine.dispose();
    }
    const mains: any = this.$refs.main;
    this.chartLine = echarts.init(mains);
    const color = [
      "#0090FF",
      "#36CE9E",
      "#FFC005",
      "#FF515A",
      "#8B5CFF",
      "#00CA69",
    ];
    const hexToRgba = (hex, opacity) => {
      let rgbaColor = "";
      const reg = /^#[\da-f]{6}$/i;
      if (reg.test(hex)) {
        rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3), 16)},${parseInt(
          "0x" + hex.slice(3, 5),
          16
        )},${parseInt("0x" + hex.slice(5, 7), 16)},${opacity})`;
      }
      return rgbaColor;
    };
    const oneOption = {
      tooltip: {
        trigger: "axis",
        formatter: (params) => {
          let html = "";
          params.forEach((v) => {
            html += `
                        <div style="font-size: 14px;line-height: 24px;text-align:left; ">
                            <div style="display: flex;align-items: center;">
                                <div style="margin-right:10px;border-radius:10px;width:10px;height:10px;background-color:${
                                  color[v.componentIndex]
                                };"></div>
                                ${
                                  v.componentIndex == 0
                                    ? this.dateList[v.dataIndex]
                                    : this.pastDateList[v.dataIndex]
                                }
                            </div>
                                <div style="margin-left: 20px;">
                                    ${
                                      this.showTitleList[v.componentIndex]
                                    }&nbsp;&nbsp;<span style="font-weight: 550;">${
              v.value
            }</span>
                                </div>
                        </div>
                    `;
          });
          return html;
        },
      },
      color: ["#0090FF", "#36CE9E", "#FFC005", "#FF515A", "#8B5CFF", "#00CA69"],
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: this.dateList,
        axisLabel: {
          textStyle: {
            color: "#000000",
            fontWeight: "bolder",
          },
        },
        nameTextStyle: {
          color: "#000000",
          fontSize: 50,
          padding: [0, 0, 0, 25],
        },
      },
      grid: {
        top: "15%",
        left: "6%",
        right: "6%",
        bottom: "5%",
      },
      yAxis: {
        // name: this.title,
        type: "value",
        axisLabel: {
          textStyle: {
            color: "#000000",
            fontWeight: "bolder",
          },
        },
        nameTextStyle: {
          color: "#000000",
          fontSize: 16,
          lineHeight: 40,
          fontWeight: "bolder",
        },
      },
      legend: {
        data: this.titleList,
        x: "center",
        y: "top",
        padding: [20, 80, 20, 0],
        border: "1px solid red",
        textStyle: {
          // 图例文字的样式
          color: "#000",
          fontSize: 16,
          fontWeight: "bolder",
          border: "1px solid red",
        },
      },
      toolbox: {
        show: true,
        orient: "vertical",
        left: "right",
        top: "center",
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ["line", "bar"] },
          restore: { show: true },
          saveAsImage: { show: true },
        },
      },
      series: this.seriesList,
    };
    const twoOption = {
      tooltip: {
        trigger: "axis",
      },
      color: ["#0090FF", "#36CE9E", "#FFC005", "#FF515A", "#8B5CFF", "#00CA69"],
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: this.dateList,
        axisLabel: {
          textStyle: {
            color: "#000000",
            fontWeight: "bolder",
          },
        },
        nameTextStyle: {
          color: "#000000",
          fontSize: 50,
          padding: [0, 0, 0, 25],
        },
      },
      grid: {
        top: "15%",
        left: "6%",
        right: "6%",
        bottom: "5%",
      },
      yAxis: {
        // name: this.title,
        type: "value",
        axisLabel: {
          textStyle: {
            color: "#000000",
            fontWeight: "bolder",
          },
        },
        nameTextStyle: {
          color: "#000000",
          fontSize: 16,
          lineHeight: 40,
          fontWeight: "bolder",
        },
      },
      legend: {
        data: this.titleList,
        x: "center",
        y: "top",
        padding: [20, 80, 20, 0],
        textStyle: {
          // 图例文字的样式
          color: "#000",
          fontSize: 16,
          fontWeight: "bolder",
        },
      },
      toolbox: {
        show: true,
        orient: "vertical",
        left: "right",
        top: "center",
        feature: {
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ["line", "bar"] },
          restore: { show: true },
          saveAsImage: { show: true },
        },
      },
      series: this.seriesList,
    };
    this.chartLine.setOption(this.timeShow ? oneOption : twoOption);
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
}
